import stylesConfig from "styles/config.json";

export type ColorTheme = (typeof stylesConfig)["colorThemes"][number];
export const COLOR_THEMES = stylesConfig["colorThemes"];
export type UserLogo = (typeof stylesConfig)["userLogos"][number];
export const USER_LOGOS = stylesConfig["userLogos"];

export enum EntryType {
  TEXT = "text",
  BUCKET = "bucket",
  WORKSPACE = "workspace",
  JOURNAL = "journal",
  JOURNAL_PAGE = "journal_page",
}

export interface EntryRef {
  entryUuid: string;
  entryType: EntryType;
  refId: string;
}

export interface WorkspaceEntryRef extends EntryRef {
  x: number;
  y: number;
  width: number;
  height: number;
  zIndex: number;
  mobileIdx?: number;
  createdAt: Date;
  updatedAt?: Date;
}

export interface BaseEntryData {
  type: EntryType;
}

export interface TextData extends BaseEntryData {
  type: EntryType.TEXT;
  text: string;
  title: string;
}

export interface WorkspaceData extends BaseEntryData {
  type: EntryType.WORKSPACE;
  name: string;
  isRoot: boolean;
  entryRefs: {[refId: string]: WorkspaceEntryRef};
}

export interface JournalData extends BaseEntryData {
  type: EntryType.JOURNAL;
  title: string;
  pageUuidsByDate: {[date: string]: string};
}

export interface JournalPageData extends BaseEntryData {
  type: EntryType.JOURNAL_PAGE;
  journalUuid: string;
  text: string;
}

export interface BucketData extends BaseEntryData {
  type: EntryType.BUCKET;
  name: string;
  entryRefs: {[refId: string]: EntryRef};
}

export type EntryData =
  | BucketData
  | TextData
  | WorkspaceData
  | JournalData
  | JournalPageData;

export interface EntryModel<T extends EntryData = EntryData> {
  uuid: string;
  data: T;
  createdAt: Date;
  updatedAt?: Date;
}

export interface EntryPointer {
  entryUuid: string;
  entryType: EntryType;
  createdAt: Date;
  updatedAt?: Date;
}

export interface UserProfile {
  rootWorkspaceUuid: string;
  rootChatUuid: string;
  manifestation: string;
  colorTheme?: ColorTheme;
  userLogo?: UserLogo,
}

export interface ChatMessage {
    role: "user"|"assistant";
    text: string;
    createdAt: Date;
}

